import Storage from "../lib/storage.js";
import Consts from "./consts.js";

class TokenStorage {
    static save(token) {
        let now = new Date().getTime();
        token.expireTime = token.expireTime * 1000 + now;
        token.refreshExpireTime = token.refreshExpireTime * 1000 + now;
        
        Storage.setLocal(Consts.STORAGE_NAME_TOKEN, token);
        
        return token;
    }
    
    static load() {
        return Storage.getLocal(Consts.STORAGE_NAME_TOKEN);
    }
    
    static clear() {
        return Storage.removeLocal(Consts.STORAGE_NAME_TOKEN);
    }
}

export default TokenStorage;